import { render, staticRenderFns } from "./CollectionDetailSkeleton.vue?vue&type=template&id=d8410baa&scoped=true"
import script from "./CollectionDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./CollectionDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetailSkeleton.vue?vue&type=style&index=0&id=d8410baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8410baa",
  null
  
)

export default component.exports